import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeft, Mail, LifeBuoy, LogIn } from 'lucide-react'
import { colors as C, fonts as F } from '../theme'
import { useIsMobile } from '../hooks/useIsMobile'
import { supabase } from '../lib/supabase'

// Page « Contact » PUBLIQUE.
//
// Le FAUX formulaire (qui ne POSTait rien) a été retiré. Le vrai canal de
// support (création de ticket + suivi « Mes demandes ») vit DANS l'application,
// derrière l'authentification — il a besoin de l'avocat connecté, du contexte
// technique et de Sentry. Cf. src/components/dashboard/SupportPanel.jsx.
//
// Comportement :
//   - visiteur connecté  → redirection vers l'app, page support (#support) ;
//   - visiteur non connecté → infos de contact (email) + accès connexion.
// Aucun formulaire fantôme.

export default function ContactPage() {
  const isMobile = useIsMobile()
  const [checking, setChecking] = useState(true)
  const [authed, setAuthed] = useState(false)

  useEffect(() => {
    let alive = true
    const session$ = supabase
      ? supabase.auth.getSession().then(({ data }) => data?.session || null)
      : Promise.resolve(null)
    session$
      .then((session) => {
        if (!alive) return
        if (session?.access_token) {
          // Connecté : on bascule vers le vrai canal support in-app.
          window.location.href = '/#support'
          setAuthed(true)
        }
        setChecking(false)
      })
      .catch(() => { if (alive) setChecking(false) })
    return () => { alive = false }
  }, [])

  return (
    <div style={{ background: C.bgPage, minHeight: '100vh' }}>
      <header style={{
        background: C.bgCard, borderBottom: `0.5px solid ${C.border}`,
        position: 'sticky', top: 0, zIndex: 100,
      }}>
        <div style={{
          maxWidth: 900, margin: '0 auto', padding: '1rem 2rem',
          display: 'flex', alignItems: 'center', gap: '1rem',
        }}>
          <Link to="/" style={{
            display: 'flex', alignItems: 'center', gap: '0.5rem',
            color: C.textPrimary, textDecoration: 'none', fontSize: '0.9rem', fontWeight: 500,
          }}>
            <ChevronLeft size={20} /> Retour
          </Link>
          <div style={{ fontSize: '1.2rem', fontFamily: F.serif, fontWeight: 400, color: C.textPrimary }}>
            IAvocat<span style={{ fontStyle: 'italic', color: C.accent }}>.ai</span>
          </div>
        </div>
      </header>

      <div style={{ maxWidth: 760, margin: '0 auto', padding: isMobile ? '1.5rem 1rem' : '3rem 2rem' }}>
        <h1 style={{
          fontFamily: F.serif, fontSize: isMobile ? '1.8rem' : '2.4rem', fontWeight: 400,
          color: C.textPrimary, letterSpacing: '-0.01em', marginBottom: '0.75rem',
        }}>
          Assistance
        </h1>
        <p style={{
          fontFamily: F.sans, fontSize: '1.05rem', color: C.textSecondary,
          marginBottom: '2.5rem', lineHeight: 1.6,
        }}>
          Une question ou un problème technique ? L'équipe IAvocat.ai vous accompagne.
        </p>

        {checking || authed ? (
          <p style={{ fontFamily: F.sans, color: C.textMuted }}>Redirection vers votre espace…</p>
        ) : (
          <div style={{ display: 'grid', gap: '1.25rem' }}>
            {/* Accès au canal in-app pour les avocats déjà clients */}
            <div style={{
              background: C.bgCard, padding: '1.75rem', borderRadius: 12,
              border: `0.5px solid ${C.border}`,
            }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
                <LifeBuoy size={22} style={{ color: C.accent, flexShrink: 0, marginTop: 2 }} aria-hidden="true" />
                <div>
                  <h2 style={{ fontFamily: F.sans, fontSize: '1.05rem', fontWeight: 600, color: C.textPrimary, margin: '0 0 0.4rem' }}>
                    Vous êtes déjà client ?
                  </h2>
                  <p style={{ fontFamily: F.sans, fontSize: '0.95rem', color: C.textSecondary, lineHeight: 1.6, margin: '0 0 1rem' }}>
                    Connectez-vous pour ouvrir une demande et suivre son traitement
                    directement depuis votre espace, dans « Mes demandes ».
                  </p>
                  <Link to="/login" style={{
                    display: 'inline-flex', alignItems: 'center', gap: 8,
                    background: C.accent, color: '#fff', textDecoration: 'none',
                    padding: '0.7rem 1.1rem', borderRadius: 10,
                    fontFamily: F.sans, fontSize: '0.95rem', fontWeight: 600,
                  }}>
                    <LogIn size={17} aria-hidden="true" /> Se connecter
                  </Link>
                </div>
              </div>
            </div>

            {/* Contact email direct */}
            <div style={{
              background: C.bgCard, padding: '1.75rem', borderRadius: 12,
              border: `0.5px solid ${C.border}`,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <Mail size={22} style={{ color: C.accent, flexShrink: 0 }} aria-hidden="true" />
                <div>
                  <div style={{ fontFamily: F.sans, fontSize: '0.85rem', color: C.textSecondary, marginBottom: '0.3rem' }}>
                    Par email
                  </div>
                  <a href="mailto:contact@iavocat.ai" style={{
                    fontFamily: F.sans, fontSize: '1rem', fontWeight: 600, color: C.accent, textDecoration: 'none',
                  }}>
                    contact@iavocat.ai
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
